<template>
  <div
    @click="$emit('click')"
    style="cursor: pointer; display: inline-block; padding-top: 3px;"
  >
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="30"
      height="30"
      viewBox="0 0 512 512"
    >
      <path
        :fill="isDarkTheme ? headingTextColor : isPopUp ? '#585957' : '#ffffff'"
        d="M405 136.798L375.202 107 256 226.202 136.798 107 107 136.798 226.202 256 107 375.202 136.798 405 256 285.798 375.202 405 405 375.202 285.798 256z"
      />
    </svg>
  </div>
</template>
<script>
export default {
  name: "CloseIcon",
  props: {
    isPopUp: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    isDarkTheme() {
      // ✅ Guard for sdkEvent and themeColors
      if (
        this.$store.state.sdkEvent &&
        this.$store.state.sdkEvent.isDarkTheme &&
        this.$store.state.sdkEvent.isDarkTheme
      ) {
        return this.$store.state.sdkEvent.isDarkTheme;
      }
      return null; // fallback
    },
    headingTextColor() {
      if (
        this.$store.state.sdkEvent &&
        this.$store.state.sdkEvent.themeColors &&
        this.$store.state.sdkEvent.themeColors.headingTextColor
      ) {
        return this.$store.state.sdkEvent.themeColors.headingTextColor;
      }
      return null;
    }
  }
};
</script>
<style scoped>
div:hover {
  opacity: 0.7;
  transition: opacity 0.2s;
}
</style>
